import React,{useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import '../Navbar/Navbar.css'
import burger from '../img/burger.png'
import carrello from '../img/carrello.png'
import indietro from '../img/indietro.png'
import { Passaggio } from '../App'

const Navbar = () => {
  const utente = useContext(Passaggio)
  const link = useNavigate()

  const passaCarrello = () => link('/carrello')
  const tornaIndietro = () => link(-1)

  return (
    <div id='navbar'>
      <div className='contlogo' onClick={()=>link('/')}>
        <div className='scritta'>MANGIUMA</div>
        <img src={burger} className='logo'/>
      </div>

      <div className='loghidx'>
        <div onClick={tornaIndietro}>
          <img src={indietro} className='logo'/>
        </div>
        <div onClick={passaCarrello} className='logocarrello'>
          <img src={carrello} className='logo'/>
          {utente.qta > 0 && <span className='qta'>{utente.qta}</span>}
        </div>
      </div>
    </div>
  )
}

export default Navbar